import Creatable from "react-select/creatable";
import styled from "styled-components";
import { reactSelectStyles } from "../StyledReactSelect/StyledReactSelect";

const StyledCreatable = styled(Creatable)`
  ${reactSelectStyles}
`;

export default StyledCreatable;
